// extracted by mini-css-extract-plugin
export default {"messageContainer":"details_messageContainer__1-WyH"};